import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseReports from '../../AbstractObjects/GatewayPlan/InnerPages/BaseReports';
import {useTranslation} from "react-i18next";
import {reportsIcon} from "../../../../assets/images/headerIcons";
const pageSchema = GatewayGetSchema.pages.reports;
const pageId = pageSchema.pageId;

function GatewayReports({
    gatewayObject,
    planObject,
    setGatewayData,
    setEditorPageId,
    isSMEReportEnabled,
    isReportConfirmationEnabled
}) {
    const { t } = useTranslation();
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];
    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.REPORTS')}
            icon={reportsIcon}
        >
            <BaseReports
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                setEditorPageId={setEditorPageId}
                isSMEReportEnabled={isSMEReportEnabled}
                isReportConfirmationEnabled={isReportConfirmationEnabled}
            />
        </LockToPlanContainer>
    );
}

export default GatewayReports;